import './App.css';
import React from 'react';
import { AppContextProvider } from './context/AppContext';
import { RouterProvider } from 'react-router-dom';
import router from './Router';
import { RestaurantContextProvider } from './context/RestaurantContext';
import MaintenanceScreen from './components/maintenanceScreen/maintenanceScreen';





const App = React.memo(() => { {

  return (
      <AppContextProvider>
        <RestaurantContextProvider>
          <div className='App' style={{backgroundColor: "#ebedee", display: "flex", flexDirection: "column"}}>
            <RouterProvider router={router}/>
          </div>
        </RestaurantContextProvider>
      </AppContextProvider>
  );
}})

export default App;
